import Env from './Env';



const envs = {
  current: null,
  envs: {},
  add(data, {isDefault = false} = {}) {
    const env = new Env(data);
    this.envs[env.type] = env;
    if (env.matched) {
      this.current = env;
      if (env.type !== 'public') {
        console.info('「' + env.name + '」環境で起動しました');
      }
    }

    if (isDefault && !this.current) {
      this.current = env;
      console.warn('環境判定に一致するものがなかったので「' + env.name + '」で起動しました');
    }
  },
  get(type) {
    return this.envs[type];
  },
  matchType(type) {
    return this.current && this.current.type === type || false;
  },
};




export default envs;


// WEBPACK FOOTER //
// ./src/js/store/modules/config/envs.js